const messages = {
  'header.brand': 'Auryc',
  'header.signup': 'Sign Up',
  'header.login': 'Login',
  'header.lang': 'Language',
  'header.search': 'Search',
  'header.xn_dashboard': 'Dashboard',
  'header.xn_realtime': 'Realtime',
  'header.xn_brand': 'Xiaoneng',

  'feature.products': 'Products',
  'feature.customers': 'Customers',
  'feature.developers': 'Developers',
  'feature.support': 'Support',
  'feature.about': 'About Us',

  'feature.dashboard': 'Dashboard',
  'feature.apps': 'Apps',
  'feature.insights': 'Insights',
  'feature.users': 'Users',
  'feature.alerts': 'Alerts',
  'feature.feedback': 'Feedback'
};

export default messages;



/** WEBPACK FOOTER **
 ** ./src/locales/en-US/messages.js
 **/